@let t = technique();
@let unit = amountUnit();

<div class="flex flex-col">
  <div class="flex flex-wrap items-baseline gap-x-1 text-sm">
    @for (element of t.generatedElements; track $index) {
      <app-icon-element-charge
        class="self-center"
        [element]="element"
        [filled]="true"
        size="sm"
        [tp]="'Generates a ' + element + ' charge'"
      />
    }

    <span class="font-semibold {{ kindClass() }} mr-1">{{ kindLabel() }}</span>

    @if (t.amount > 0) {
      <span class="font-semibold">{{ t.amount | number }}</span>
      @if (unit) {
        <span class="font-semibold">{{ unit }}</span>
      }
    }

    @if (t.summonName) {
      <span class="font-semibold">{{ t.summonName }}</span>
    } @else {
      <span class="text-lighter">
        to
        @if (t.targeting.count !== undefined) {
          {{ t.targeting.count | number }}
        }
        {{ t.targeting.noun }}
      </span>
    }

    @if (t.accuracy < 100) {
      <span class="text-lighter">({{ t.accuracy | number }}% to hit)</span>
    }
  </div>

  @if (t.scaling.length > 0) {
    <div class="type-meta">
      @for (entry of t.scaling; track entry.stat; let last = $last) {
        {{ entry.multiplier | number: '1.2-2' }}x {{ statShorthand[entry.stat]
        }}{{ last ? '' : ' + ' }}
      }
    </div>
  }

  @for (effect of t.statusEffects; track effect.name) {
    <div class="text-xs">
      {{ statusVerb() }} {{ effect.name }} for
      {{ effect.duration | number }}
      {{ effect.duration === 1 ? 'turn' : 'turns' }}
      @if (effect.chance < 100) {
        <span class="text-lighter">({{ effect.chance | number }}% chance)</span>
      }
    </div>
  }

  @for (condition of t.conditions; track $index) {
    <div class="type-meta">{{ condition }}</div>
  }
</div>
